"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const SvgSparkles = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.962 1.501a.75.75 0 0 0-.674.512l-.943 2.832-2.832.943a.75.75 0 0 0 0 1.424l2.83.944.945 2.831a.75.75 0 0 0 1.424 0l.943-2.832 2.832-.943a.75.75 0 0 0 0-1.424l-2.832-.943-.943-2.832a.75.75 0 0 0-.75-.512M6 4.623l.35 1.052a.75.75 0 0 0 .475.474l1.052.351-1.052.35a.75.75 0 0 0-.474.475L6 8.377l-.35-1.052a.75.75 0 0 0-.475-.474L4.123 6.5l1.052-.35a.75.75 0 0 0 .474-.475zm9.72 1.378a.75.75 0 0 0-.684.52l-1.463 4.552-4.552 1.463a.75.75 0 0 0 0 1.428l4.552 1.463 1.463 4.553a.75.75 0 0 0 1.428 0l1.463-4.553 4.553-1.463a.75.75 0 0 0 0-1.428l-4.553-1.463-1.463-4.552A.75.75 0 0 0 15.72 6m.03 3.2.867 2.697a.75.75 0 0 0 .485.485l2.698.867-2.698.867a.75.75 0 0 0-.485.485L15.75 17.3l-.867-2.698a.75.75 0 0 0-.484-.485L11.7 13.25l2.699-.867a.75.75 0 0 0 .484-.485zM5.212 14a.75.75 0 0 0-.674.512l-.757 2.27-2.268.755a.75.75 0 0 0 0 1.424l2.268.756.757 2.27a.75.75 0 0 0 1.424 0l.756-2.27 2.27-.756a.75.75 0 0 0 0-1.424l-2.27-.757-.756-2.268a.75.75 0 0 0-.75-.512m.038 3.121.163.49a.75.75 0 0 0 .475.475l.489.163-.49.163a.75.75 0 0 0-.474.475l-.163.49-.164-.49a.75.75 0 0 0-.475-.475l-.489-.163.49-.163a.75.75 0 0 0 .474-.475z"
  }));
};
var _default = exports.default = SvgSparkles;